import { setDrawer } from 'common_packages/assets/js/actions/uiActions'
import { type TDispatch } from 'common_packages/assets/js/types/TDispatch'
import { drawerTypes } from 'common_packages/assets/js/types/drawerTypes'
import { Props as UpgradeDrawerData } from 'client/pages/common/components/drawer/account/DrawerContentUpgradeComponent'

type ShowUpgradeDrawerProps = {
  hideClose?: boolean,
  drawerData?: UpgradeDrawerData
}

export const showSubscribeDrawer = () => (dispatch: TDispatch) => {
  dispatch(setDrawer({
    drawer: drawerTypes.SUBSCRIBE,
    forceModal: true,
    hideHeader: true,
    bleedToEdge: true,
    modalAutoGrow: true,
    size: 'large',
  }))
}

export const showUpgradeDrawer = ({ hideClose = false, drawerData }: ShowUpgradeDrawerProps = {}) => (dispatch: TDispatch) => {
  dispatch(setDrawer({
    drawer: drawerTypes.UPGRADE,
    drawerData,
    forceModal: true,
    hideHeader: true,
    bleedToEdge: true,
    modalAutoGrow: true,
    hideClose,
  }))
}
